import { ContactSection } from "../components/ContactSection";
import { SecurityQuiz } from "../components/SecurityQuiz";
import { useSEO } from "../lib/useSEO";

export default function ContactPage() {
  useSEO({
    title: "Contact Us — Request a UK Security Quote",
    description: "Speak to a UK security consultant at USI Security. Request a no-obligation quote for SIA-licensed manned guarding, CCTV tower hire, K9 patrols or 24/7 monitoring — nationwide UK coverage.",
    keywords: "UK security quote, request security quote, manned guarding quote, CCTV tower quote, security consultant UK, hire security guards UK",
    path: "/contact",
  });
  return (
    <div data-testid="contact-page" className="pt-24">
      <section className="relative py-20 lg:py-28 border-b border-white/10">
        <div className="absolute inset-0 grid-bg opacity-30" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(6,182,212,0.1),transparent_50%)]" />
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-cyan-400 mb-4">◆ Contact</p>
          <h1 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-7xl leading-[1.02] tracking-tighter max-w-4xl">
            Let's design the right<br />
            <span className="text-gradient-cyan">security stack for you.</span>
          </h1>
          <p className="mt-6 text-lg text-slate-400 max-w-2xl leading-relaxed">
            Talk to a UK consultant — no obligation, no sales pressure. We'll review your operational risks and propose a tailored solution within one working day.
          </p>
        </div>
      </section>

      <ContactSection />
      <SecurityQuiz />
    </div>
  );
}
